export default __webpack_public_path__ + "static/media/cs_CZ.b912ddee.svg";